module.exports = __webpack_public_path__ + "static/media/Picker_niveau2_elVide_1373600465.afa47baa.png";